import React from 'react';

import Skeleton from 'react-loading-skeleton';

const LoadingSkeleton = () => {
  const style = {
    margin: '10px 0',
  };

  return (
    <>
      <Skeleton height="40px" style={style} />
      <Skeleton height="16px" style={style} />
      <Skeleton height="48px" style={style} />
      <Skeleton height="16px" style={style} />
      <Skeleton height="32px" style={style} />
      <Skeleton height="16px" style={style} />
      <Skeleton height="48px" style={style} />
    </>
  );
};

export default LoadingSkeleton;
